import React, { memo } from 'react';
import VWCoinChart from '../CustomChart';
import Banner from '../CustomBanner';
import { ICoinsChartData } from '../../../../types/coins';

interface CustomHeaderProps {
  value: number;
  title: string;
  dataChart: ICoinsChartData[];
}

const CustomHeader: React.FC<CustomHeaderProps> = ({ value, title, dataChart = [] }) => (
  <div className="display-flex flex-row align-items-stretch width-100pct height-150 bg-white rounded-large shadow-default">
    <Banner value={value} title={title} />
    <div className="display-flex align-items-center min-width-0 width-100pct">
      <VWCoinChart data={dataChart} />
    </div>
  </div>
);

export default memo(CustomHeader);